export function fuzzySearch(query: string, target: string): boolean {
  // escape special regex characters in the query string
  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  // create a new regex with the escaped query string and the global and case-insensitive flags
  const regex = new RegExp(escapedQuery, "gi")
  // test if the target string matches the regex

  return regex.test(target)
}


// 异步生成 SHA-256 摘要（返回 hex 字符串）
export async function jsonHash(obj: object): Promise<string | null> {
  // 兼容性处理，虽然对于现代浏览器根本不会发生这种情况
  if (typeof window?.crypto?.subtle?.digest !== "function") {
    return null
  }

  const str = JSON.stringify(obj)

  const encoder = new TextEncoder()
  const data = encoder.encode(str)

  const hashBuffer = await window.crypto.subtle.digest("SHA-256", data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))

  return hashArray.map(b => b.toString(16).padStart(2, "0")).join("")
}
